export default "__VITE_ASSET__DUsBdSBT__"